<template>
    <div class="row">
        <div class="col-lg-12">
            <curator-info :id="id"></curator-info>

            <h4 class="row-title pt-2">{{'user.attached_therapist_list' | trans }}</h4>
            <therapist-list></therapist-list>

            <h4 class="row-title pt-4">{{'protocol.bids_for_protocols' | trans }}</h4>
            <bids-list :userId="id"></bids-list>
        </div>
    </div>
</template>

<script>
  import BidsList from '@/modules/bids/components/BidsList';
  import {showModal} from '../../../../../common/mixins/showModal';
  import CuratorInfo from './CuratorInfo';
  import TherapistList from './list/AttachedTherapistList';

  export default {
    name: 'CuratorProfile',
    props: ['id'],

    mixins: [showModal],

    components: {
      CuratorInfo, BidsList, TherapistList,
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/user/curator/profile/components/Profile.vue